import * as React from 'react';
import classNames from 'classnames';

interface Props {
  active?: boolean;
  selected?: string;
  sortOptions?: any;
  onSelectChange?: any;
  forSheet?: boolean;
  hidden?: boolean;
}

function NO_OP() { }

const style = {
  label: 'ui-popover__container shop-filters__select-wrapper',
  sheet: 'shop-filters__select-wrapper--sheet',
  hidden: 'shop-filters__select-wrapper--hidden',
  labelText: 'shop-filters__select-in-field',
  selectWrap: 'marketing-select-wrapper shop-filters__select-wrapper',
};

const SORT = 'sort';

export class FilterSort extends React.PureComponent<Props> {

  render() {
    const {
      active,
      hidden = false,
      forSheet = false,
      selected,
      sortOptions = [],
      onSelectChange = NO_OP,
    } = this.props;

    const selectId = `${forSheet ? 'sheet:' : ''}${SORT}`;

    if (!active) {
      return (
        <select
          id={selectId}
          name={selectId}
          disabled={!active}
          value={selected}
          onChange={onSelectChange}
        >
          {sortOptions.map(({label, value}) => (
            <option
              key={value}
              value={value}
            >{label}</option>
          ))}
        </select>
      );
    }

    return (
      <label
        className={classNames(style.label, {
          [style.sheet]: forSheet,
          [style.hidden]: hidden,
        })}
        htmlFor={SORT}
      >
        <span className={style.labelText}>Sort:</span>
        <select
          id={selectId}
          name={selectId}
          disabled={!active}
          value={selected}
          onChange={onSelectChange}
        >
          {sortOptions.map(({label, value}) => (
            <option
              key={value}
              value={value}
            >{label}</option>
          ))}
        </select>
      </label>
    );
  }
}

export default FilterSort;
